import { CheckCircle2 } from "lucide-react";
import { useEffect, useState } from "react";
import { app, pages } from "@microsoft/teams-js";

export default function TeamsConfigPage() {
  const [ready, setReady] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let mounted = true;

    async function configure() {
      try {
        await withTimeout(app.initialize(), 1600);
        pages.config.registerOnSaveHandler((saveEvent) => {
          pages.config
            .setConfig({
              contentUrl: `${window.location.origin}/teams`,
              websiteUrl: `${window.location.origin}/`,
              suggestedDisplayName: "People Admin",
              entityId: "people-admin"
            })
            .then(() => saveEvent.notifySuccess())
            .catch((configError) => saveEvent.notifyFailure(String(configError)));
        });
        pages.config.setValidityState(true);
        app.notifySuccess();
        if (mounted) {
          setReady(true);
        }
      } catch (configError) {
        if (mounted) {
          setError(configError instanceof Error ? configError.message : "Teams configuration failed.");
        }
      }
    }

    configure();
    return () => {
      mounted = false;
    };
  }, []);

  return (
    <main className="status-surface">
      <section className="status-panel">
        <CheckCircle2 size={30} aria-hidden="true" />
        <h1>People Admin</h1>
        <p>{ready ? "Ready to add as a channel tab." : error || "Preparing Teams tab configuration..."}</p>
      </section>
    </main>
  );
}

function withTimeout<T>(promise: Promise<T>, timeoutMs: number): Promise<T> {
  return new Promise((resolve, reject) => {
    const timeout = window.setTimeout(() => reject(new Error("Teams SDK initialization timed out.")), timeoutMs);
    promise
      .then((value) => {
        window.clearTimeout(timeout);
        resolve(value);
      })
      .catch((error) => {
        window.clearTimeout(timeout);
        reject(error);
      });
  });
}
